<template>
  <b-container>
    <b-row>
      <b-col
        v-if="$ability.can('read', 'Product_images')"
        lg="1"
        md="2"
      >
        <ProductCardSwiper
          :title="product.Name"
          :images="product.images"
          :images-small="product.images.small"
          :images-full="product.images.full"
        />
      </b-col>
      <b-col
        lg="11"
        md="10"
      >
        <b-row>
          <b-col
            v-if="$ability.can('read', 'Product_brand')"
            md="2"
          >
            <InformationBasicCard
              title="Marca"
              :tags="[{ value: product.name_brand, type: 'string' }]"
            />
          </b-col>
          <b-col
            v-if="$ability.can('read', 'Product_model')"
            md="2"
          >
            <InformationBasicCard
              title="Modelo"
              :tags="[{ value: product.Model, type: 'string' }]"
            />
          </b-col>
          <b-col
            v-if="$ability.can('read', 'Product_category')"
            md="2"
          >
            <InformationBasicCard
              title="Categoría y subcategoría"
              :tags="[{ value: `Categoría: ${product.TrueCategory ? product.TrueCategory.Name : 'Sin categoría'}`, type: 'string' },
                      { value: `Subcategoría: ${product.name_categorie}`, type: 'string' }]"
            />
          </b-col>
          <b-col
            v-if="product.Type === 'Nuevo' && $ability.can('read', 'Product_code')"
            md="2"
          >
            <InformationBasicCard
              title="Código interno"
              :tags="[{ value: product.Code, type: 'string' }]"
            />
          </b-col>
          <b-col
            v-if="product.Type === 'Nuevo' && $ability.can('read', 'Product_item')"
            md="2"
          >
            <InformationBasicCard
              title="Item"
              :tags="[{ value: product.Item, type: 'string' }]"
            />
          </b-col>
          <b-col
            v-if="$ability.can('read', 'Product_color_paint') && $ability.can('read', 'Product_color_tapestry')"
            md="2"
          >
            <InformationBasicCard
              title="Color pintura y tapiz"
              :tags="[{ name: product.NamePaint, value: product.CodePaint, type: 'color' },
                      { name: product.NameTapestry, value: product.CodeTapestry, type: 'color' }]"
            />
          </b-col>
          <b-col
            v-if="product.Type === 'Usado' && $ability.can('read', 'Product_prices_list')"
            md="2"
          >
            <div
              class="mt-1"
            >
              <h5 class="font-weight-bolder">
                Precios
              </h5>
              <b-form-radio-group
                v-model="selectedPrice"
                :options="pricesListOptions"
                :name="idRadioButtons"
                :disabled="disabledFormComponents"
                stacked
              />
            </div>
          </b-col>
          <b-col
            v-if="userData.Role !== 'Encargado de Facturacion'"
            md="2"
          >
            <InformationBasicCard
              title="Cantidad"
              :tags="[{ value: product.pieces.length, type: 'string' }]"
            />
          </b-col>
          <!-- #region::Rating level for used product coordinator -->
          <b-col
            v-if="canShowProductRatingLevel"
            :md="2"
          >
            <InformationBasicCard
              title="Nivel de habilitación"
              :tags="[{ value: formatUsedProductRatingLevel(product.UnitPriceType), type: 'string' }]"
            />
          </b-col>
          <!-- #endregion::Rating level for used product coordinator -->
          <b-col
            v-if="(byWholesaler && canShowPriceWholesaler) && userData.Role !== 'Coordinador de Almacen'"
            md="2"
          >
            <InformationBasicCard
              v-if="product.PriceMax"
              title="Precios"
              :tags="[{ value: product.PriceMinWholesaler, prepend: 'Mín:', type: 'currency' },
                      { value: product.PriceMaxWholesaler, prepend: 'Máx:', type: 'currency' }]"
            />
            <InformationBasicCard
              v-else
              title="Precios"
              :tags="[{ value: 'Precios por definir', type: 'string' }]"
            />
          </b-col>
          <b-col
            v-else-if="userData.Role !== 'Coordinador de Almacen' && product.Type !== 'Usado'"
            md="2"
          >
            <InformationBasicCard
              v-if="product.PriceMin"
              title="Precios"
              :tags="[{ value: product.PriceMin, prepend: 'Mín:', type: 'currency' },
                      { value: product.PriceMax, prepend: 'Máx:', type: 'currency' },
                      ... product.OfferPrice ? [{ value: product.OfferPrice, prepend: 'Oferta:', type: 'currency', style: 'color: #FF7766;' }] : []]"
            />
            <InformationBasicCard
              v-else
              title="Precios"
              :tags="[{ value: 'Precios por definir', type: 'string' }]"
            />
          </b-col>
          <b-col
            v-if="userData.Role !== 'Coordinador de Almacen'"
            md="2"
          >
            <InformationBasicCard
              title="Precio Unitario"
              :tags="[{ value: product.UnitPrice, type: 'currency' }]"
            />
          </b-col>
          <b-col
            v-if="userData.Role !== 'Coordinador de Almacen'"
            md="2"
          >
            <InformationBasicCard
              title="Subtotal"
              :tags="[{ value: product.Subtotal, type: 'currency' }]"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-button
        :variant="visible ? 'flat-primary' : 'flat-secondary'"
        class="btn-icon rounded-circle ml-1 toggle-button"
        @click="collapse"
      >
        <feather-icon :icon="iconToggle" />
      </b-button>
    </b-row>
  </b-container>
</template>

<script>
import {
  BRow, BCol, VBTooltip, BContainer, BFormRadioGroup, BButton,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'

import validateCurrency from '@/helpers/CurrencyFormat'
import usedProductRatingLevel from '@/helpers/UsedProductRatingLevel'
import ProductCardSwiper from '@/components/swipers/ProductCardSwiper.vue'
import InformationBasicCard from '@/components/cards/InformationBasicCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    VBTooltip,
    ProductCardSwiper,
    BContainer,
    BFormRadioGroup,
    InformationBasicCard,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    disabledFormComponents: {
      type: Boolean,
      default: true,
    },
    byWholesaler: {
      type: Boolean,
      default: false,
    },
    iconToggle: {
      type: String,
      default: 'ChevronDownIcon',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      selectedPrice: '',
      pricesListOptions: [],
      valuePrice: '',
      idRadioButtons: '',
    }
  },
  computed: {
    canShowNormalPricesList() {
      return (this.product.Type === 'Nuevo' || this.product.Type === 'Remanufacturado')
        && this.$ability.can('read', 'Product_prices_list')
    },
    canShowPriceWholesaler() {
      return this.product.PricesDefinedWholesaler
        && (this.product.Type === 'Nuevo' || this.product.Type === 'Remanufacturado')
        && this.$ability.can('read', 'Product_prices_wholesaler')
    },
    normalPricesDefined() {
      return this.product.PriceMin && this.product.PriceMax
    },
    wholesalerPricesDefined() {
      return this.product.PriceMinWholesaler && this.product.PriceMaxWholesaler
    },
    baseListPrice() {
      if (this.userData.Role !== 'Mayorista') {
        return true
      }

      return this.checkPrices
    },
    maxPrice() {
      if (this.product.MaxSuggestedPrice) {
        return `Precio máximo: ${this.isValidCurrency(this.product.MaxSuggestedPrice)}`
      }

      return 'Precio máximo: sin especificar'
    },
    baseWholesalerPrice() {
      if (this.userData.Role !== 'Mayorista') {
        return true
      }

      return !this.checkPrices
    },
    checkPrices() {
      if (!this.normalPricesDefined && this.wholesalerPricesDefined) {
        return false
      }

      if (this.normalPricesDefined && this.wholesalerPricesDefined) {
        return false
      }

      if (!this.normalPricesDefined && !this.wholesalerPricesDefined) {
        return true
      }

      if (this.normalPricesDefined && !this.wholesalerPricesDefined) {
        return true
      }

      return true
    },
    /**
     * Determina si se puede mostrar el nivel de habilitación del producto
     */
    canShowProductRatingLevel() {
      return this.$ability.can('read qualification_level', 'Order')
        && this.product.Type === 'Usado'
        && this.product.UnitPriceType
    },
  },
  watch: {
    selectedPrice() {
      if (this.product.Type === 'Usado') {
        switch (this.selectedPrice) {
          case 'PriceLf':
            this.valuePrice = this.product.PriceLf
            break

          case 'PriceDr':
            this.valuePrice = this.product.PriceDr
            break

          default:
            this.valuePrice = this.product.PriceDr + 1
            break
        }

        this.product.unitPriceType = this.selectedPrice
      }
    },
  },
  created() {
    if (this.product.Type === 'Usado') {
      this.pricesListOptions = [
        { text: `L/F: ${this.isValidCurrency(this.product.PriceLf)}`, value: 'PriceLf' },
        { html: `D/R: ${this.isValidCurrency(this.product.PriceDr)} <br/><small>${this.maxPrice}</small>`, value: 'PriceDr' },
        ...this.product.OfferPrice ? [{ html: `<span style="color: #FF7766;">Oferta: ${this.isValidCurrency(this.product.OfferPrice)}</span>`, value: 'OfferPrice' }] : [],
        { text: 'R:', value: 'R' },
      ]

      // ... product.OfferPrice ? [{ value: product.OfferPrice, prepend: 'Oferta:', type: 'currency', style: 'color: #FF7766;' }] : []]"

      // this.selectedPrice = 'PriceSt'
      this.selectedPrice = this.product.UnitPriceType
      // this.valuePrice = this.product.PriceSt
      this.valuePrice = this.product.UnitPriceOrigin
      this.idRadioButtons = uuidv4()
    }
  },
  methods: {
    collapse() {
      this.$emit('toggle-collapse')
    },

    /**
     * Formatea el nivel de habilitación del producto
     *
     * @param {string} price Precio del producto
     * @returns {string} Nivel de habilitación del producto
     */
    formatUsedProductRatingLevel(price) {
      return usedProductRatingLevel(price)
    },

    /**
    * Validacion de datos numéricos
    *
    * @summary Valida si los datos numéricos son válidos y se aplica el formato de moneda
    * @param {String} value - Valor a validar
    * @return {String} Valor con formato de moneda
    */
    isValidCurrency(value) {
      return validateCurrency(value)
    },
  },
}
</script>
